import React, { useState, useEffect } from 'react';
import { List, Button, Space, Tag, message, Tooltip, Layout, Typography } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';
import axios from 'axios';
import { setAuthToken } from '../../utils/auth';
import { changeOrderCustomer } from '../../services/orderService';
import { columnStyle } from '../orders/OrderListStyles';
import OrderList from '../orders/OrderList';
import OrderDetailModal from '../orders/OrderDetailModal';
import '../orders/OrderList.css';

const { Content } = Layout;
const { Text } = Typography;
const DEFAULT_PAGE_SIZE = 500;

const OrderManagement = () => {
  const [loading, setLoading] = useState(false);
  const [orders, setOrders] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [searchResults, setSearchResults] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: DEFAULT_PAGE_SIZE,
    total: 0,
    showSizeChanger: true,
    pageSizeOptions: [500, 1000, 2000],
    showTotal: (total) => `共 ${total} 条订单`
  });

  useEffect(() => {
    // Initialize auth token
    const token = localStorage.getItem('token');
    if (token) {
      setAuthToken(token);
    }
    fetchOrders();
  }, []);

  const fetchOrders = async (page = 1, pageSize = DEFAULT_PAGE_SIZE) => {
    try {
      setLoading(true);
      const response = await axios.get(`/api/orders/all/?page=${page}&page_size=${pageSize}`);
      setOrders(response.data.results);
      setPagination({
        ...pagination,
        current: page,
        pageSize: pageSize,
        total: response.data.count
      });
    } catch (error) {
      console.error('Error fetching orders:', error);
      if (error.response?.status === 403) {
        message.error('没有权限访问此功能');
      } else {
        message.error('加载订单数据失败');
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (page, pageSize) => {
    fetchOrders(page, pageSize);
  };

  const handleOrderClick = (order) => {
    setSelectedOrder(order);
    setModalVisible(true);
  };

  const handleSearchResults = (results) => {
    setSearchResults(results);
    setPagination({
      current: 1,
      pageSize: results.length,
      total: results.length
    });
  };

  const handleClearSearch = () => {
    setSearchResults(null);
    fetchOrders(1, DEFAULT_PAGE_SIZE);
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: 'calc(100vh - 48px)' }}>
      <Content style={{ 
        background: '#fff',
        flexGrow: 1,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column'
      }}>
        <OrderList
          orders={searchResults || orders}
          loading={loading}
          pagination={pagination}
          onPageChange={handlePageChange}
          onOrderClick={handleOrderClick}
          onOrdersUpdate={searchResults ? handleSearchResults : fetchOrders}
          onSearchResults={handleSearchResults}
          onClearSearch={handleClearSearch}
          isSearchMode={!!searchResults}
          showBatchButtons={true}
          totalOrders={pagination.total}
          isOrderManagementTab={true}
          onChangeCustomer={async (orderIds, customerId) => {
            try {
              await changeOrderCustomer(orderIds, customerId);
              fetchOrders();
            } catch (error) {
              throw error;
            }
          }}
        />
      </Content>

      <OrderDetailModal
        visible={modalVisible}
        order={selectedOrder}
        onClose={() => setModalVisible(false)}
      />
    </div>
  );
};

export default OrderManagement;
